import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useEditAssetGroupSubmit } from '../../hooks'
import { getLandscapeLogoData } from '../HeadlinesSection/helpers'
import { isAllImageAssetsReady } from '../../helpers'

import EditForm from '../../../../../../../features/components/Forms/EditForm'
import MultipleGoogleMediaUpload from '../../../GoogleAssetGroupCreate/GoogleAssetGroupForm/GoogleAssetGroupMainForm/MultipleGoogleMediaUpload'

import { selectedGoogleAdAccountSelector } from '../../../../../../../modules/selectors/adAccounts'

import { googleAssetFieldType } from '../../../../../../../constants/ads'
import { LANDSCAPE_LOGO, landscapeLogoHeight, landscapeLogoWidth } from '../../../../fields'
import { getInitialValues } from './fields'
import { landscapeLogoValidationSchema } from '../../../../validations'

const LandscapeLogoSectionForm = ({ editItemData, isInternalAssetGroup, title, ...formProps }) => {
  const { assets, id: assetGroupId, account } = editItemData

  const { id: selectedAdAccountId } = useSelector(selectedGoogleAdAccountSelector)
  const adAccount = account || selectedAdAccountId

  const originalLandscapeLogoAssets = useMemo(() => getLandscapeLogoData(assets), [assets])

  const initialValues = useMemo(() => getInitialValues(originalLandscapeLogoAssets), [originalLandscapeLogoAssets])

  const { purifiedFormik, onClearSubmit, isLoadingSelector, errorSelector, successSubmit } = useEditAssetGroupSubmit({
    originalSectionAssets: originalLandscapeLogoAssets,
    fieldType: googleAssetFieldType.LANDSCAPE_LOGO,
    sectionValueKey: LANDSCAPE_LOGO,
    assetGroupId,
    isInternalAssetGroup,
    initialValues,
    title,
    adAccount
  })

  const { values } = purifiedFormik

  const isImagesReady = isAllImageAssetsReady(values, LANDSCAPE_LOGO)

  const isEmptyList = !values[LANDSCAPE_LOGO].length

  return (
    <EditForm
      formik={purifiedFormik}
      initialValues={initialValues}
      isLoadingSelector={isLoadingSelector}
      errorSelector={errorSelector}
      successSubmit={successSubmit}
      clearEditItem={onClearSubmit}
      submitBtnDisabled={!isImagesReady}
      {...formProps}
    >
      <MultipleGoogleMediaUpload
        formik={purifiedFormik}
        FileItemPath={LANDSCAPE_LOGO}
        validationSchema={landscapeLogoValidationSchema}
        addAnotherButtonText={isEmptyList ? 'Add landscape logo' : 'Add another landscape logo'}
        width={landscapeLogoWidth}
        height={landscapeLogoHeight}
      />
    </EditForm>
  )
}

export default LandscapeLogoSectionForm
